<!--
 * @Author: 王丛
 * @Date: 2021-12-30 22:19:04
 * @LastEditors: 王丛
 * @LastEditTime: 2022-01-06 13:36:09
 * @Description: 联想词
-->
<template>
  <div class="automated-keyword">
    <ul>
      <li
        v-for="res in keywordList"
        :key="res + Math.random()"
        @click="clickItem(res.item)"
      >
        {{ res.item }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    // 联想词列表
    keywordList: {
      type: Array,
      default: () => {},
    },
  },
  methods: {
    /**
     * 点击联想词
     *
     * @param {string} item
     */
    clickItem(item) {
      this.$emit('clickItem', item);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.automated-keyword {
  background: #fff;
  li {
    height: rem(42);
    padding-left: rem(15);
    line-height: rem(42);
    text-align: left;
    border-top: 1px solid #f4f4f4;
  }
}
</style>
